module.exports = __webpack_public_path__ + "static/media/onboarding_logo.4dc13ca0.png";